import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SHUTDOWN_DATE_TEXT, isAfterShutdown } from "../../shutdown";

export default function ShutdownBanner() {
  const { t } = useTranslation();
  const closed = isAfterShutdown();
  return (
    <div
      role="alert"
      className="w-full rounded-lg bg-amber-500/15 border border-amber-400/50 text-amber-100 text-sm px-4 py-2 mt-3 flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3"
    >
      <span className="font-semibold">
        {closed
          ? t("shutdown_banner_closed")
          : t("shutdown_banner", { date: SHUTDOWN_DATE_TEXT })}
      </span>
      <Link to="/shutdown" className="underline underline-offset-2 sm:ml-auto whitespace-nowrap">
        {t("shutdown_banner_link")}
      </Link>
    </div>
  );
}
